import produce from 'immer';

const INITIAL_STATE = {
  loading: false,
};

export default function role(state = INITIAL_STATE, action) {
  return produce(state, draft => {
    switch (action.type) {
      case '@role/SAVE_REQUEST': {
        draft.loading = true;
        break;
      }
      case '@role/SAVE_SUCCESS': {
        draft.loading = false;
        break;
      }
      case '@role/SAVE_FAILURE': {
        draft.loading = false;
        break;
      }
      case '@role/UPDATE_REQUEST': {
        draft.loading = true;
        break;
      }
      case '@role/UPDATE_SUCCESS': {
        draft.loading = false;
        break;
      }
      case '@role/UPDATE_FAILURE': {
        draft.loading = false;
        break;
      }
      default:
    }
  });
}